import axios from 'axios'

// URL on server might be different than on local development environment.
// note that sfb1454.iaas.uni-bonn.de/database makes use of an NGINX reverse
// proxy on the uniVM to allow the REST API to live under the /database tree
const API_SUFFIX_FOR_DEPLOYMENT = ''
// const API_URL_FOR_DEPLOYMENT = 'https://sfb1454.iaas.uni-bonn.de'
const API_URL_FOR_DEPLOYMENT = 'https://metaflammdb-test.cf-rdm.info/'
const BASE_URL_FOR_DEPLOYMENT = `${API_URL_FOR_DEPLOYMENT}/${API_SUFFIX_FOR_DEPLOYMENT}`
const BASE_URL_FOR_DEVELOPMENT = 'http://localhost:8181'
const doDeploy = true

export default () => {
  return axios.create({
    baseURL: doDeploy ? BASE_URL_FOR_DEPLOYMENT : BASE_URL_FOR_DEVELOPMENT
    // baseURL: `${BASE_URL_FOR_DEVELOPMENT}` // for local development
    // baseURL: `${BASE_URL_FOR_DEPLOYMENT}` // for deployment
  })
}



// WEBPACK FOOTER //
// ./src/services/API.js